import request from '../../plugins/request'

// const baseUrl = 'http://novel.atxg.world:4003'

export function getAuthorUserInfo(data){
	return request({
		url:`/api/AuthorUser/GetAuthorUserInfo`,
		method:'POST',
		data:data,
	})
}

//解锁数
export function getUnlockCount(data){
	return request({
		url:`/api/Reports/GetUnlockCount`,
		method:'POST',
		data:data,
		baseURL: `${process.env.VUE_APP_NOVEL_API}`
	})
}
//作品数
export function getGoodsCount(data){
	return request({
		url:`/api/Reports/GetGoodsCount`,
		method:'POST',
		data:data,
		baseURL: `${process.env.VUE_APP_NOVEL_API}`
	})
}

//游客浏览作者首页记录
export function getVisitorCount(data){
	return request({
		url:`/api/Reports/GetVisitorCount`,
		method:'POST',
		data:data,
		baseURL: `${process.env.VUE_APP_NOVEL_API}`
	})
}

export function updateAuthorUserInfo(data){
	return request({
		url:`/api/AuthorUser/UpdateAuthorUserInfo`,
		method:'POST',
		data:data,
		// baseURL: `${process.env.VUE_APP_NOVEL_API}`
	})
}
export function getBannerListByParams(data) {
  return request({
    url: '/api/Banner/GetBannerListByParams',
    method: 'post',
    data: data,
	baseURL: `${process.env.VUE_APP_NOVEL_API}`
  })
}